import { Plus } from "lucide-react";
import Button from "../../../components/common/button";
import { SupplierTable } from "./supplierTable";
import { useEffect, useState } from "react";
import { useAuthData } from "../../../context/AuthContext";

export const Suppliers = () => {
  const [email, setEmail] = useState<any>(null);
  const [role, setRole] = useState<any>(null);
  const { adminData } = useAuthData();

  useEffect(() => {
    const getData = async () => {
      if (adminData) {
        setEmail(adminData?.email);

        if (adminData?.role) {
          setRole(adminData?.role);
        }
      }
    };

    getData();
  }, [adminData]);

  return (
    <>
      <div className="px-4 md:px-6 pt-6 pb-16 flex flex-col gap-4 md:gap-6">
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-1">
            <h1 className="text-darkBlack font-medium text-xl md:text-2xl desktop:text-[30px]">
              Leverandører
            </h1>
            <p className="text-gray text-sm md:text-base">
              Liste over alle leverandører
            </p>
          </div>
          <div className="flex gap-3">
            {(email === "andre.finger@gmail.com" || role === "Admin") && (
              <Button
                text="Legg til"
                className="border border-primary bg-primary text-white text-sm rounded-[8px] h-[40px] font-medium relative px-4 py-[10px] flex items-center gap-2"
                icon={<Plus className="text-white w-5 h-5" />}
                path="/legg-til-leverandor"
              />
            )}
          </div>
        </div>
        <SupplierTable />
      </div>
    </>
  );
};
